<template>
  <div>
    <div
      class="mysidebar"
      :class="expandbar == true ? 'expand-bar' : ''"
      @click="showSideBar"
    >
      <div class="menu-list">
        <input
          type="text"
          class="form-control searchtextbox"
          placeholder="&#128269; Search"
          v-model="lookfor"
          autocomplete="off"
        />
        <!-- Menu Items -->
        <menu-item
          :menuname="'Dashboard'"
          :menuicon="'fa-solid fa-house'"
          :withsubmenu="false"
        ></menu-item>
        <menu-item
          v-for="(menu, index) in menuList"
          :key="index"
          :menuname="menu.menuname"
          :menuicon="menu.menuicon"
          :submenu="menu.submenu"
          :withsubmenu="true"
          :show_submenu="lookforLength"
          @submenuclick="subclick"
        >
        </menu-item>

        <!-- Menu Item List -->
      </div>
    </div>
    <div class="bg-div" v-if="expandbar" @click="hideSideBar"></div>
  </div>
</template>
<script>
import MenuItem from "./MenuItem";
import axios from "axios";

export default {
  components: {
    MenuItem,
  },
  data() {
    return {
      mainmenu: [],
      lookfor: "",
      expandbar: false,
    };
  },
  methods: {
    subclick(event) {
      if (event) event.stopPropagation();
      this.hideSideBar();
    },
    showSideBar() {
      this.expandbar = true;
    },
    hideSideBar() {
      this.expandbar = false;
    },
    getMenu() {
      axios
        .post("menu.php", {
          optn: "getmenu",
          userId: this.$store.state.userId,
        })
        .then((response) => {
          this.mainmenu = response.data.Menu;
        });
    },
  },
  computed: {
    menuList() {
      return this.mainmenu
        .map((r) => {
          var arr = r.submenu[0].filter((rw) => {
            return rw.menuname
              .trim()
              .toLowerCase()
              .includes(this.lookfor.trim().toLowerCase());
          });
          return arr.length > 0 ? { ...r, submenu: [arr] } : null;
        })
        .filter(Boolean);
    },
    lookforLength() {
      return this.lookfor.length > 0 ? true : false;
    },
  },
  mounted() {
    this.getMenu();
  },
};
</script>

<style>
@import "../css/base.css";
</style>
<style scoped>
.bg-div {
  position: fixed;
  top: 0px;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.212);
  z-index: 9;
}
.mysidebar {
  position: fixed;
  /* width: 200px; */
  min-width: 55px;
  width: 55px;
  max-width: 280px;
  height: 100vh;
  clear: both;
  float: left;
  background-color: white;
  transition: ease-in-out 0.3s all;
  overflow-x: hidden;
  z-index: 10;
  top: 0px;
  box-shadow: 0px 0px 4px 1px lightgray;
}
.mysidebar:hover {
  width: 280px;
}

.mysidebar:hover .searchtextbox {
  width: 100%;
}
.expand-bar {
  width: 280px;
}
.searchtextbox {
  position: relative;
  margin-left: 6px;
  max-width: calc(100% - 36px);
  min-width: 20px;
  width: 20px;
  border-radius: 15px;
  top: 10px;
}
.expand-bar .searchtextbox {
  width: 100%;
}

.menu-list {
  position: relative;
  display: block;
  /* width: calc(230px - 5px); */
  width: calc(270px - 5px);
  height: fit-content;
  top: 55px;
  margin-bottom: 150px;
}

/* .menu-list .form-control {
} */
::-webkit-scrollbar {
  width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

@media only screen and (max-width: 600px) {
  .mysidebar {
    min-width: 40px;
    width: 40px;
  }
  .searchtextbox {
    min-width: 15px;
    width: 15px;
    margin-left: 5px;
    padding: 6px;
  }
}
</style>
